// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bookmarks {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin-bottom: -2vh;
  overflow: hidden;
  width: 100%;
}

#bookmarks #filters {
  display: none;
}

#filter {
  align-items: center;
  display: flex;
  justify-content: right;
  margin: 2vh 7.5% 1vh 7.5%;
}

#filter img {
  cursor: pointer;
  display: block;
  height: 2rem;
  margin-bottom: 0.2rem;
}

#filter.open #filters {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/bookmarks/Bookmarks.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf","sourcesContent":["#bookmarks {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  margin-bottom: -2vh;\n  overflow: hidden;\n  width: 100%;\n}\n\n#bookmarks #filters {\n  display: none;\n}\n\n#filter {\n  align-items: center;\n  display: flex;\n  justify-content: right;\n  margin: 2vh 7.5% 1vh 7.5%;\n}\n\n#filter img {\n  cursor: pointer;\n  display: block;\n  height: 2rem;\n  margin-bottom: 0.2rem;\n}\n\n#filter.open #filters {\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
